





















































import scrollToElement from 'scroll-to-element'
import Vue from 'vue'
import { Component, Inject, Prop, Watch } from 'vue-property-decorator'

import { log } from '@/log'
import { ParameterList } from '@/models/api/payment/parameter/parameter'
import UserSelect, { SelectOption, SelectOptionList } from '@/models/api/payment/parameter/type/user-select'
import { Payment } from '@/models/api/payment/payment'
import { ErrorBag } from '@/services/payment/options-validator'
import { SelectItem } from '@spa/components/atoms/model/SelectItem'
import SpaAcordionLike from '@spa/components/atoms/transition/AcordionLike.vue'
import PaymentDescription from '@spa/components/organisms/order/edit/payment/select/description/PaymentDescription.vue'
import { Validator } from 'vee-validate'

@Component({
  components: {
    SpaAcordionLike,
    PaymentDescription,
  },
})
export default class PaymentSelectItem extends Vue {
  @Inject()
  $validator: Validator

  /**
   * Vee-validateと、独自実装したバリデーションの二種類が併存しているので、統合を検討。
   */
  @Prop({ required: true })
  validation: ErrorBag

  @Prop({ required: true })
  payment: Payment

  @Prop({ required: true })
  selectedPaymentId: string

  @Prop({ required: true })
  selectedPaymentOptions: SelectOptionList

  /**
   * NOTE: 再注文時だけ使われる
   * TODO: 美ラボ・ホテラバリリース後すぐにリファクタリングしてこのプロパティを削除する
   * @see: https://github.com/my-color/front/issues/5077
   */
  @Prop({ required: false })
  disabled: boolean

  /**
   * 選択されたラジオボタンが画面上部（ヘッダの下部付近）に表示されるように、画面をスクロールする。
   * このコメントからも分かるように、本来であればこのスクロールは、画面全体の配置を制御するより上位のコンポーネントで実装するほうが望ましい。
   * しかし一旦簡便のため、各ラジオボタンに相当するこのコンポーネントで実装する。
   *
   * これに伴い、このコンポーネントを他の画面で使い回す場合は、適切に複製、または上位コンポーネントに処理を委譲することを検討する。
   */
  @Watch('isSelected')
  scrollRadioToPageTop() {
    if (!this.isSelected) return

    const top = this.$refs['top']
    scrollToElement(top, {
      /**
       * ヘッダの高さ + 余白程度の数値を指定している。
       * このコンポーネントがどのような画面に配置されるか、またその画面でどのようなヘッダが使われるかに依存しているので、
       * こうした依存関係は取り除くことが望ましい。
       * @link https://github.com/my-color/front/pull/6368#discussion_r852510751
       */
      offset: -50,
      ease: 'in-sine',
      duration: 1,
    })
  }

  get radioId(): string {
    return `radio-${this.payment.id}`
  }

  get isSelected(): boolean {
    return this.payment.id === this.selectedPaymentId
  }

  get userSelectList(): ParameterList<UserSelect> {
    return this.payment.userSelectParameters
  }

  get pulldowns(): UserSelect[] {
    return this.userSelectList.filter(p => p.select === 'single').list
  }

  /**
   * 将来的に、バリデーションの内容に応じてメッセージが複数種類発生したり、それら複数のメッセージの表示場所が別々になるようであれば、
   * 適宜このコンポーネントのようなビュー層で、望ましい形に出し分けること。
   */
  get validationMessage(): string {
    if (this.selectedPaymentId !== this.payment.id) {
      return ''
    }

    return this.validation.validationMessageFor(this.payment.id)
  }

  valueForUserSelect(param: UserSelect): string {
    const option = this.findOption(param.id)
    if (!option) {
      return ''
    }

    return option.id
  }

  validationForUserSelect(param: UserSelect): any {
    return {
      required: param.required,
    }
  }

  createSelectItemFromUserSelect(param: UserSelect): SelectItem[] {
    const option = this.findOption(param.id)

    return [
      {
        text: '選択してください',
        value: '',
        disabled: true,
        selected: !option,
      },
      ...param.options.map(o => ({
        text: o.label,
        value: o.id,
        selected: (option !== null) && option.equalTo(o),
      })),
    ]
  }

  onPaymentChecked() {
    this.$emit('select', this.payment)
  }

  onInputForPulldown(param: UserSelect, optionId: string) {
    const option = param.options.find(o => o.id === optionId)

    if (option === null) {
      log.warn({
        message: 'Not found option id on pulldown select',
        parameter: param,
        option_id: optionId,
      })

      return
    }

    this.$emit('option-select', option)
  }

  private findOption(parameterId: string): SelectOption | null {
    return this.selectedPaymentOptions.find(o => o.parameterId === parameterId)
  }
}
